module.exports = __webpack_public_path__ + "img/communication _ man, guy, person, table, stool, chair, laptop, computer, conversation, chat.c7de8040.svg";